interface HtcAvailabilityDevToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/** Dev-only toggle standing in for PM-submitted Hours to Complete data. */
export function HtcAvailabilityDevToggle({ checked, onChange }: HtcAvailabilityDevToggleProps) {
  if (!import.meta.env.DEV) return null;

  return (
    <div className="mt-2 flex flex-wrap items-center gap-4 rounded-md border border-dashed border-amber-400 bg-amber-50 px-3 py-2 text-xs dark:bg-amber-950/20">
      <span className="font-semibold text-amber-700 dark:text-amber-400">DEV</span>
      <label className="flex items-center gap-1.5 cursor-pointer text-amber-800 dark:text-amber-300">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="accent-amber-500"
        />
        <span>htcAvailable (mock PM-submitted data)</span>
      </label>
    </div>
  );
}
